var _style, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEggAppHiddenEggGolden(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 604 768",
    style: {
      enableBackground: "new 0 0 604 768"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:#FFCE00;}\n\t.st5{fill:#FF6900;}\n\t.st6{fill:#FF4600;}\n\t.st7{fill:#FFAF00;}\n\t.st8{fill:#FF1700;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.2961,
    y1: 383.7515,
    x2: 604,
    y2: 383.7515
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4600"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M604,465.95c0,6.78-0.23,13.52-0.67,20.19c-1.52,23.22-5.67,45.71-12.17,67.19 c-6.05,20.08-14.15,39.27-24.05,57.34C515.86,704.31,416.42,767.8,302.15,767.8c-116.97,0-218.4-66.53-268.51-163.81 c-9.65-18.74-17.4-38.62-22.99-59.39c-5.07-18.83-8.35-38.38-9.68-58.46c-0.44-6.67-0.67-13.41-0.67-20.2 c0-4.82,0.11-9.77,0.34-14.81c1.01-22.57,4.24-47.16,9.46-72.85c4.42-21.71,10.25-44.2,17.41-66.89 c16.13-51.31,38.88-103.65,66.65-150.43c11.87-20.01,24.66-39,38.26-56.45C180.77,42.4,239.2-0.3,302.15-0.3 c61.84,0,119.35,41.22,167.2,101.61c13.52,17.02,26.24,35.58,38.08,55.16c29.63,48.93,53.73,104.3,70.42,158.35 c7.06,22.81,12.8,45.41,17.09,67.18c4.8,24.34,7.76,47.66,8.72,69.16C603.89,456.18,604,461.13,604,465.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.0929,
    y1: 360.3243,
    x2: 594.9448,
    y2: 360.3243
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5842,
    style: {
      stopColor: "#FF4600"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M594.94,381.99l-76.82,66.43l-108.98-94.23l-108.72,94.01l-105.88-91.57L89.79,447.21l-79.69-68.91 c4.42-21.71,10.25-44.2,17.41-66.89l62.28,53.86l104.76-90.58l105.88,91.57l108.72-94.02l108.98,94.23l59.74-51.65 C584.92,337.62,590.66,360.22,594.94,381.99z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.1396,
    y1: 589.3073,
    x2: 337.1211,
    y2: 589.3073
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4600"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M591.16,553.33c-6.05,20.08-14.15,39.27-24.05,57.34c-69.6,15.09-158.39,23.34-252.83,23.34 c-103.29,0-199.84-9.86-271.9-27.76c-2.96-0.74-5.88-1.48-8.75-2.25c-9.65-18.74-17.4-38.62-22.99-59.39 c12.28,4.57,26.79,9.03,43.76,13.25c68.23,16.95,160.52,26.29,259.88,26.29s191.65-9.34,259.88-26.29 C580.05,556.39,585.73,554.88,591.16,553.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.1531,
    y1: 127.1639,
    x2: 353.1641,
    y2: 127.1639
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4600"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M507.43,156.46c-56.96-8.64-123.31-13.25-193.16-13.25c-81.18,0-157.65,6.24-220.12,17.76 c11.87-20.01,24.66-39,38.26-56.45c55.07-7.3,117.14-11.17,181.87-11.17c54.43,0,106.98,2.74,155.08,7.95 C482.87,118.32,495.59,136.88,507.43,156.46z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 91.26,
    cy: 276.62,
    r: 17.52
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 303.5,
    cy: 277.29,
    r: 17.52
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 519.1,
    cy: 277.29,
    r: 17.52
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 194.34,
    cy: 468.65,
    r: 17.52
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 409.95,
    cy: 468.65,
    r: 17.52
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17.81,468.65c0,9.45-7.48,17.15-16.84,17.5c-0.44-6.67-0.67-13.41-0.67-20.2c0-4.82,0.11-9.77,0.34-14.81 C10.15,451.32,17.81,459.08,17.81,468.65z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M604,465.95c0,6.78-0.23,13.52-0.67,20.19c-9.37-0.34-16.84-8.04-16.84-17.49c0-9.57,7.67-17.33,17.18-17.5 C603.89,456.18,604,461.13,604,465.95z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggAppHiddenEggGolden);
export default __webpack_public_path__ + "static/media/EggApp_HiddenEgg_Golden.6161eef0da9bda096d8b19218bd8ea2d.svg";
export { ForwardRef as ReactComponent };